<template>
	<v-layout row wrap fill-height class="admin-attributes">
		<v-flex xs12 md3>
			<v-card>
				<v-list class="py-0 admin__sidebar-menu" dark>
					<v-list-tile ripple to="/admin/attributes/import" avatar class="secondary">
						<v-list-tile-avatar>
							<div class="v-icon secondary theme--dark">
								<fa-icon :icon="['far', 'cogs']" size="xs" />
							</div>
						</v-list-tile-avatar>

						<v-list-tile-content>
							<v-list-tile-title>Import Attributes</v-list-tile-title>
						</v-list-tile-content>
					</v-list-tile>
				</v-list>

				<v-list class="py-0 admin__sidebar-menu" v-if="$vuetify.breakpoint.mdAndUp">
					<v-list-tile
						ripple
						avatar
						v-for="attribute in attributes"
						:key="attribute.id"
						:to="`/admin/attributes/${attribute.id}`"
					>
						<v-list-tile-content>
							<span v-html="attributeName(attribute)"></span>
						</v-list-tile-content>
					</v-list-tile>
				</v-list>

				<v-list v-else class="py-0">
					<v-list-group :value="listOpen" @click="listOpen = !listOpen">
						<v-list-tile slot="activator" class="decision-tree__category">
							<v-list-tile-content>
								<v-list-tile-title>All Attributes</v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>

						<v-list-tile
							ripple
							avatar
							v-for="attribute in attributes"
							:key="attribute.id"
							@click="listOpen = false"
							:to="`/admin/attributes/${attribute.id}`"
						>
							<v-list-tile-content>
								<span v-html="attributeName(attribute)"></span>
							</v-list-tile-content>
						</v-list-tile>
					</v-list-group>
				</v-list>
			</v-card>
		</v-flex>

		<v-flex xs12 md9 v-if="$route.fullPath.indexOf('/attributes/') >= 0">
			<router-view :key="$route.fullPath"></router-view>
		</v-flex>
	</v-layout>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { log } from "util";

export default {
	data() {
		return {
			listOpen: false
		};
	},

	props: {
		id: {
			default: null
		}
	},

	computed: {
		...mapGetters(["searchQuery"]),

		...mapGetters("admin", {
			ATTRIBUTES: "attributes"
		}),

		searchRegex() {
			return (flags = "gi") => new RegExp(this.searchQuery, flags);
		},

		attributes() {
			let attributes = this.ATTRIBUTES;

			if (this.searchQuery) {
				let sq = this.searchQuery.toLowerCase();

				attributes = _.filter(attributes, attribute => {
					return (
						this.getObjectValue("name", attribute, "")
							.toLowerCase()
							.indexOf(sq) >= 0
					);
				});
			}

			return _.orderBy(attributes, [attribute => attribute.name]);
		}
	},

	methods: {
		...mapActions("admin", {
			GET_ATTRIBUTES: "getAttributes"
		}),

		attributeName(attribute) {
			let attribute_name = attribute.name;

			if (this.searchQuery) {
				return this.highlight(attribute_name);
			}

			return attribute_name;
		},

		highlight(text, flags) {
			return (text = text.replace(this.searchRegex(flags), found => {
				return `<span class="search-highlight">${found}</span>`;
			}));
		}

		// addUser() {
		// 	this.showAddUserForm = true;
		// }
	},

	created() {
		this.GET_ATTRIBUTES();
	}
};
</script>
